import {Route, Routes, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {InitContextProvider, setNavigate} from "@follosoft/react-components";

import FlowPage from "@/pages/flow.tsx";
import DefaultLayout from "@/layouts/default.tsx";
import LoginPage from "@/pages/login";
import {FlowContextProvider} from "@/contexts/FlowContext.tsx";
import AuthLayout from "@/layouts/auth.tsx";
import { useTranslation } from "react-i18next";
import ServiceCallPage from "@/app/service-calls/page";
import InvoicePayPage from "@/app/invoices/[invoice]/pay/page";
import ContractUpdatePage from "@/app/contract-updates/page";
import { DebugPanel } from "@/app/_debug-panel";

// import {InitContextProvider} from "@/contexts/InitContext.tsx";

function App() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    sessionStorage.setItem("language", i18n.language);
  }, [i18n.language]);

  return (
    <>
      <InitContextProvider>
      <Routes>
        <Route element={<FlowContextProvider><DefaultLayout/></FlowContextProvider>} path="/">
          <Route index element={<FlowPage/>}/>
        </Route>
        <Route element={<AuthLayout/>} path="/">
          <Route element={<LoginPage/>} path="login"/>
        </Route>
        <Route element={<ServiceCallPage/>} path="service-calls/:message"/>
        <Route element={<InvoicePayPage/>} path="invoices/:invoice/pay"/>
        <Route element={<ContractUpdatePage/>} path="contracts/:contractId/contract-updates-review"/>
      </Routes>
      </InitContextProvider>
      {/* Outside the init gate: it must open even when the backend it switches does not answer. */}
      <DebugPanel/>
    </>
  );
}

export default App;
